import gql from 'graphql-tag';

const DomainFragment = gql`
  fragment DomainFragment on DomainsV1 {
    description
    displayColor
    id
    name
    slug
    keywords
    backgroundImageUrl
    subdomains {
      elements {
        ...SubdomainFragment
      }
    }
  }
`;

const SubdomainFragment = gql`
  fragment SubdomainFragment on SubdomainsV1 {
    id
    domainId
    slug
    name
    description
  }
`;

export const DomainSubdomainQuery = gql`
  query DomainSubdomainQuery(
    $isDomainSlugDefined: Boolean!
    $domainSlug: String!
    $isSubdomainSlugDefined: Boolean!
    $subdomainSlug: String!
  ) {
    DomainsV1Resource @include(if: $isDomainSlugDefined) {
      slug(slug: $domainSlug) {
        elements {
          ...DomainFragment
        }
      }
    }
    SubdomainsV1Resource @include(if: $isSubdomainSlugDefined) {
      slug(slug: $subdomainSlug) {
        elements {
          ...SubdomainFragment
        }
      }
    }
  }
  ${DomainFragment}
  ${SubdomainFragment}
`;
